import { fetcher } from '@commenda/utils';

export async function unassignMemberFromAffiliateFirmClient(
  affiliateFirmId: string,
  companyId: number,
  userId: string
) {
  const response = await fetcher(
    `affiliate-firms/${affiliateFirmId}/clients/${companyId}/member/${userId}`,
    {
      method: 'DELETE',
    }
  );

  return response;
}
